import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/admin/financial`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('adminToken');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

export const getFinancialDashboard = async (startDate = null, endDate = null) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    
    const response = await axios.get(`${API}/dashboard?${params.toString()}`, {
      headers: getAuthHeaders()
    });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.detail || 'Failed to fetch financial data'
    };
  }
};

export const getDriverEarnings = async (driverId, period = 'monthly') => {
  try {
    const response = await axios.get(`${API}/driver-earnings/${driverId}?period=${period}`, {
      headers: getAuthHeaders()
    });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.detail || 'Failed to fetch driver earnings'
    };
  }
};

export const getAllTransactions = async (limit = 100, skip = 0) => {
  try {
    const response = await axios.get(`${API}/transactions?limit=${limit}&skip=${skip}`, {
      headers: getAuthHeaders()
    });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.detail || 'Failed to fetch transactions'
    };
  }
};

export const getCompensations = async (startDate = null, endDate = null, driverId = null) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    if (driverId) params.append('driver_id', driverId);

    const response = await axios.get(`${API}/compensations?${params.toString()}`, {
      headers: getAuthHeaders()
    });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.detail || 'Failed to fetch compensations'
    };
  }
};

export const getReferralPayouts = async (startDate = null, endDate = null, userId = null) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    if (userId) params.append('user_id', userId);

    const response = await axios.get(`${API}/referral-payouts?${params.toString()}`, {
      headers: getAuthHeaders()
    });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.detail || 'Failed to fetch referral payouts'
    };
  }
};
